import React from "react";
import "./AttendanceSummary.css"; // custom CSS file

const AttendanceSummary = ({color, label, value, total, onClick = null}) => {
  return (
    <div className="summary-container" onClick={onClick}>
        <div className="summary-card">
          <div className={`summary-dot`}>
            <span className={`dot_ ${color}`}></span>
          </div>
          <div className="summary-label">{label}</div>
          <div className="summary-value">
            <strong>{String(value).padStart(2, "0")}</strong>/{total}
          </div>
        </div>
    </div>
  );
};

export default AttendanceSummary;
